import { render, staticRenderFns } from "./SetupCompanyForm.vue?vue&type=template&id=74b761b8&scoped=true"
import script from "./SetupCompanyForm.vue?vue&type=script&lang=js"
export * from "./SetupCompanyForm.vue?vue&type=script&lang=js"
import style0 from "./SetupCompanyForm.vue?vue&type=style&index=0&id=74b761b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b761b8",
  null
  
)

export default component.exports